import { getPrintJob } from '@client-shared/api/print-jobs.api.js'

import constants from '@/config/constants'

const isPdfGenerationActive = (printJob) => {
  const status = printJob?.pdfGeneration?.status

  return status === constants.PDF_GENERATION_STATUS.PENDING ||
    status === constants.PDF_GENERATION_STATUS.PROCESSING
}

// Print jobs are ephemeral (created per print action, not part of any loaded
// list), so unlike plans/photos/locationLayers this store only keeps the active
// jobs by id. Its sole purpose is to bridge the async PDF render: the
// PRINT_JOB_UPDATE socket event commits the updated job here, and the open print
// overlay reacts to its pdfGeneration.status via a getById watcher.
export default {
  namespaced: true,

  state: () => {
    return {
      byId: {},
    }
  },

  getters: {
    getById: (state) => {
      return printJobId => state.byId[printJobId]
    },
  },

  mutations: {
    UPSERT_PRINT_JOB (state, printJob) {
      state.byId = {
        ...state.byId,
        [printJob._id]: printJob,
      }
    },

    FULL_RESET (state) {
      state.byId = {}
    },
  },

  actions: {
    // Websocket reconnect catch-up: a PRINT_JOB_UPDATE that fired while the
    // socket was down is lost, leaving a job stuck pending/processing in the
    // store (and the overlay spinning forever). Re-fetch every still-active job
    // so a render that finished during the outage is recovered and its watcher
    // can resume the download. A failed fetch is swallowed — it must not break
    // the wider reconnect refetch.
    async refetchActive ({ state, commit }) {
      const activeJobs = Object.values(state.byId)
        .filter(isPdfGenerationActive)

      await Promise.all(activeJobs.map(async ({ _id }) => {
        try {
          const printJob = await getPrintJob({
            axios: this.$axios,
            printJobId: _id,
          })

          commit('UPSERT_PRINT_JOB', printJob)
        } catch {
          // ignore — the next reconnect (or a fresh click) retries
        }
      }))
    },
  },
}
